import { observer } from "mobx-react";
import React, { useContext } from "react";
import { Paper, Title, Text, List, ThemeIcon } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { SatoshiConverterStoreContext } from "../stores/SatoshiConverterStore";
import { t } from "../helpers/translations";

const SatoshiExplainer: React.FC = observer(() => {
  const store = useContext(SatoshiConverterStoreContext);
  const code = store.currencyCode.toUpperCase();
  const name = store.currencyName;
  const s = store.strings;

  return (
    <>
      <Paper
        p="lg"
        radius="md"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <Title order={2} c="white" mb="sm" size="h3">
          {s.whatIsASatoshi}
        </Title>
        <Text c="dimmed" size="sm" mb="md">
          {s.whatIsASatoshiBody}
        </Text>

        <Title order={3} c="white" mb="xs" size="h4">
          {s.howSatoshisWork}
        </Title>
        <List
          spacing="xs"
          size="sm"
          c="dimmed"
          icon={
            <ThemeIcon color="orange" size={20} radius="xl">
              <IconCheck size={12} />
            </ThemeIcon>
          }
        >
          <List.Item>
            <Text span c="white" fw={500}>
              {s.fixedSupplyLabel}
            </Text>{" "}
            {s.fixedSupplyText}
          </List.Item>
          <List.Item>
            <Text span c="white" fw={500}>
              {s.hundredMillionLabel}
            </Text>{" "}
            {s.hundredMillionText}
          </List.Item>
          <List.Item>
            <Text span c="white" fw={500}>
              {s.whySatoshisMatterLabel}
            </Text>{" "}
            {s.whySatoshisMatterText}
          </List.Item>
          <List.Item>
            <Text span c="white" fw={500}>
              {s.lightningNetworkLabel}
            </Text>{" "}
            {s.lightningNetworkText}
          </List.Item>
        </List>
      </Paper>

      <Paper
        p="lg"
        radius="md"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <Title order={3} c="white" mb="sm" size="h4">
          {t(s.convertingSatoshisTo, { name, code })}
        </Title>
        <Text c="dimmed" size="sm" mb="sm">
          {t(s.conversionExplanation, { name, code })}
        </Text>
        <Text
          c="dimmed"
          size="sm"
          mb="sm"
          style={{ fontFamily: "courier-prime, monospace" }}
        >
          10,000 sats ÷ 100,000,000 = 0.0001 BTC
          <br />
          0.0001 BTC ×{" "}
          {store.btcPriceInFiat.toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })}{" "}
          {code}/BTC ={" "}
          {(0.0001 * store.btcPriceInFiat).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          })}{" "}
          {code}
        </Text>
        <Text c="dimmed" size="sm">
          {t(s.calculatorExplanation, { name, code })}
        </Text>
      </Paper>

      <Paper
        p="lg"
        radius="md"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <Title order={3} c="white" mb="sm" size="h4">
          {s.quickReference}
        </Title>
        <Text
          c="dimmed"
          size="sm"
          style={{ fontFamily: "courier-prime, monospace" }}
        >
          1 sat {"          "}= 0.00000001 BTC
          <br />
          100 sats {"       "}= 0.000001 BTC
          <br />
          10,000 sats {"    "}= 0.0001 BTC
          <br />
          1,000,000 sats {"  "}= 0.01 BTC
          <br />
          100,000,000 sats = 1 BTC
        </Text>
      </Paper>
    </>
  );
});

export default SatoshiExplainer;
